"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var form_constants_1 = require("./form-constants");
/**
 * For an applicable element, return a plain text version of the response. Group elements are supported as well
 * @param element the element in the form
 * @param allElementResponses all element responses for the form
 * @returns the plain text string, or null if none can be determined
 */
function getPlainTextValue(element, allElementResponses) {
    var response;
    switch (element.type) {
        case form_constants_1.elementTypes.email:
        case form_constants_1.elementTypes.nationalId:
        case form_constants_1.elementTypes.number:
        case form_constants_1.elementTypes.phone:
        case form_constants_1.elementTypes.postalCode:
        case form_constants_1.elementTypes.text:
        case form_constants_1.elementTypes.textArea:
        case form_constants_1.elementTypes.specialText:
        case form_constants_1.elementTypes.gisCoordinates:
            response = allElementResponses.find(function (e) { return e.id === element.id; });
            if (response && (typeof response.value === "string" || typeof response.value === "number")) {
                return response.value + "";
            }
            break;
        case form_constants_1.elementTypes.group:
            // get subelement values
            var groupElement = element;
            var groupElementValue = "";
            var subEl;
            var subElValue;
            for (var i = 0; i < groupElement.subElements.length; i++) {
                subEl = groupElement.subElements[i];
                subElValue = this.getPlainTextValue(subEl, allElementResponses);
                if (subElValue) {
                    groupElementValue = groupElementValue ? groupElementValue + " " + subElValue : subElValue;
                }
            }
            return groupElementValue ? groupElementValue : null;
        case form_constants_1.elementTypes.checkbox:
        case form_constants_1.elementTypes.select:
        case form_constants_1.elementTypes.likert:
        case form_constants_1.elementTypes.radio:
            response = allElementResponses.find(function (e) { return e.id === element.id; });
            if (response && Array.isArray(response.value) && response.value.length > 0) {
                var responseArr = response.value;
                var responses = responseArr.map(function (id) {
                    var option = element.options.find(function (option) { return option.value === id; });
                    return option && option.label;
                });
                return responses.join(", ");
            }
            break;
        case form_constants_1.elementTypes.date:
            response = allElementResponses.find(function (e) { return e.id === element.id; });
            if (response && typeof response.value === "string") {
                var date = new Date(response.value);
                return date.toLocaleDateString();
            }
            break;
        case form_constants_1.elementTypes.duration:
            response = allElementResponses.find(function (e) { return e.id === element.id; });
            if (response && typeof response.value === "object") {
                var hours = response.value.hours;
                var mins = response.value.minutes;
                if (hours !== undefined || mins !== undefined) {
                    if (typeof hours === "number") {
                        var strValue = hours !== 0 ? hours + (hours === 1 ? " hour" : " hours") : "";
                        if (typeof mins === "number" && mins !== 0) {
                            var minuteText = mins + (mins === 1 ? " minute" : " minutes");
                            strValue = strValue ? strValue + ", " + minuteText : minuteText;
                        }
                        return strValue;
                    }
                    else if (typeof mins === "number") {
                        return mins + " minutes";
                    }
                }
            }
            break;
        case form_constants_1.elementTypes.time:
            response = allElementResponses.find(function (e) { return e.id === element.id; });
            if (response && typeof response.value === "object") {
                var hour = response.value.hour;
                var min = response.value.minute;
                var period = response.value.period;
                if (hour !== undefined && min !== undefined) {
                    var strValue = hour + ":" + min;
                    if (period) {
                        strValue = strValue + " " + period;
                    }
                    return strValue;
                }
            }
            break;
        case form_constants_1.elementTypes.electronicSignature:
        case form_constants_1.elementTypes.attachment:
        default:
            response = allElementResponses.find(function (e) { return e.id === element.id; });
            break;
    }
    if (response && typeof response.value === "string") {
        return response.value;
    }
    return null;
}
exports.getPlainTextValue = getPlainTextValue;
//# sourceMappingURL=form-element-utilities.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/form-definition/form-element-utilities.js
// module id = 1148
// module chunks = 0